<template>
  <el-row class="ios-preview-wrapper">
    <div class="ios-layout">
      <div class="display-container">
        <img src="@/img/mobile-preview-bg.jpg" class="preview-background" />

        <img src="@/img/iphone_bang.png" class="iphone-bang" />
        <div
          class="preview-wrapper"
          :class="`preview-${position}`"
          :style="wrapperStyles"
        >
          <div class="preview-header" :style="headerStyles"></div>
          <inbox-preview
            :logo-url="logoUrl"
            :push-notification-switch="pushNotificationSwitch"
            :inbox-background-color="colors.inbox_background_color"
            :inbox-border-color="colors.inbox_border_color"
            :inbox-separator-color="colors.inbox_separator_color"
            :header-background-color="colors.header_background_color"
            :header-border-color="colors.header_border_color"
            :header-icon-color="colors.header_icon_color"
            :header-text-color="colors.header_text_color"
            :message-title-color="colors.notification_title_color"
            :message-text-color="colors.notification_text_color"
            :message-date-color="colors.notification_date_color"
            :switch-on-color="colors.switch_on_color"
          ></inbox-preview>
        </div>
      </div>
      <img width="350" src="@/img/ios-preview-frame.png" />
    </div>
  </el-row>
</template>
<script>
import InboxPreview from '@/modules/settings/components/InboxPreview'

export default {
  name: 'IosInboxPreview',
  components: { InboxPreview },
  props: {
    logoUrl: String,
    pushNotificationSwitch: Number,
    position: {
      type: String,
      validator: value => {
        return ['left', 'right'].indexOf(value) !== -1
      }
    },
    colors: Object
  },
  computed: {
    wrapperStyles() {
      return {
        backgroundColor: this.colors.inbox_background_color,
        boxShadow: `0px 3px 6px ${this.colors.inbox_border_color}`
      }
    },
    headerStyles() {
      return {
        backgroundColor: this.colors.header_background_color
      }
    }
  }
}
</script>

<style scoped>
.ios-preview-wrapper {
  min-width: 300px;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #f5f7fa;
}
.ios-layout {
  display: block;
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translate(-50%, 0%);
  -webkit-transform: translate(-50%, 0%); /* Safari and Chrome */
  -moz-transform: translate(-50%, 0%); /* Firefox */
  -ms-transform: translate(-50%, 0%); /* IE 9 */
  -o-transform: translate(-50%, 0%); /* Opera */
}
.iphone-bang {
  width: 170px;
  position: absolute;
  left: 62px;
  z-index: 2;
}
.display-container {
  width: 292px;
  height: 632px;
  background-color: white;
  position: absolute;
  left: 30px;
  top: 14px;
  border-radius: 30px;
  overflow: hidden;
}
.preview-wrapper {
  width: 85%;
  height: 100%;
  overflow: hidden;
  position: absolute;
}
.preview-header {
  width: 100%;
  height: 24px;
}
.preview-left {
  left: -4px;
}
.preview-right {
  right: -4px;
}
.preview-background {
  width: 100%;
  position: absolute;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/IosInboxPreview.vue